import { render, staticRenderFns } from "./treeChild.vue?vue&type=template&id=fb7b912c&"
import script from "./treeChild.vue?vue&type=script&lang=ts&"
export * from "./treeChild.vue?vue&type=script&lang=ts&"
import style0 from "./treeChild.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports